<template>
  <div class="">
    <!-- <transition name="slide" mode="out-in"> -->
    <loading pic="loading" v-if="loadingState" key="1" />

    <div v-else class="client__wrapper" key="2">
      <div class="clients__manipulate">
        <div class="clients__actions">
          <button
            type="submit"
            @click="newExpense()"
            class="action_btn client__add"
          >
            <svg
              version="1.1"
              id="Layer_1"
              x="0px"
              y="0px"
              viewBox="0 0 1438.958 1667.496"
              enable-background="new 0 0 1438.958 1667.496"
              xml:space="preserve"
              fill="var(--purple)"
              width="50px"
              height="50px"
            >
              <g>
                <path
                  d="M1339.623,490.369c-132.244-112.003-77.63-61.316-200.037-144.892c-43.852-29.94-38.266-33.611-60.652-45.357   c-8.836-4.636-16.637-11.01-25.698-15.245c-16.481-7.702-17.803-14.874-39.676-22.677c-49.706-17.73-70.66-34.65-85.975-40.495   c-7.971-3.042-9.248,2.784-14.897-2.737c-12.799-12.509-26.183,23.554,0.821,38.793c9.817,5.54-0.261,3.404,14.529,18.192   c4.418,4.418,22.859,17.149,24.506,17.864c9.339,4.054,16.57,10.982,23.881,17.74c8.533,7.888-3.436,53.182,22.918,77.081   c5.359,4.86,15.297,5.155,20.269,0.027c2.338-2.412,4.991-3.58,7.875-4.619c37.08-13.362,32.146-7.932,48.121,4.924   c3.409,2.743,1.563,3.479,7.987,10.575c15.672,17.31,39.619,42.189,56.425,65.662c4.455,6.223,1.824,8.249-0.084,7.288   c-1.002-0.505-55.786-17.316-80.271-17.828c-11.865-0.248-23.293-3.798-35.223-3.524c-4.821,0.111-9.896,1.073-14.71-0.733   c0,0-3.384,0.743-12.695,0.776c-16.123,0.057-32.024,1.759-47.641,5.852c-53.851,14.116-43.461,26.77-62.876,17.055   c-70.463-35.262-82.038-36.92-123.622-57.823c-45.116-22.679-61.646-39.315-98.666-54.077   c-45.024-17.953-142.147-42.126-159.026-48.3c-12.062-4.412-21.231-11.103-32.223-17.423   c-80.487-46.276-171.439-73.595-228.12-139.092c-5.143-5.943-12.318-10.075-15.703-17.579c-0.268-0.595-1.052-1.125-1.71-1.35   c-4.474-1.533-6.624-7.038-11.997-6.995c-12.569-9.872-68.26-46.648-80.18-59.079c-6.361-6.633-13.231-12.199-23.078-12.836   c-5.978-0.386-11.018-4.009-16.474-6.162c-21.39-8.439-27.054-14.967-33.135-18.672c-4.966-3.026-10.626,1.724-11.621,7.875   c-1.678,10.372,2.623,10.311-1.983,15.665c-4.715,5.48-4.848,10.455,2.343,15.904c0.147,0.111,0.301,0.229,0.471,0.292   c4.264,1.571-0.296,2.893,2.284,9.23c1.054,2.588,2.785,4.667,4.922,6.358c-8.151,9.589,1.939,15.574,8.487,16.407   c-0.595,2.82-8.872,2.648-3.507,10.928c4.573,7.059,9.443,6.064,10.416,11.035c0.196,1,11.063,15.834,24.276,22.181   c3.355,1.612,16.571,14.467,30.133,25.165c17.371,13.702,12.115,21.872,21.529,35.881c12.044,17.922,23.674,13.085,30.082,15.002   c6.257,1.872,17.753-0.939,22.885-2.378c2.906-0.815,10.697,0.166,9.88,3.075c-1.952,6.946,1.361,17.269-1.256,20.258   c-1.372,1.567,0.163,3.666,2.08,2.24c0.662-0.492,1.583-1.877,2.126-0.729c1.146,2.422,4.851,1.833,5.266,5.195   c0.362,2.934,7.021,2.167,7.098-2.146c0.066-3.708-3.767-4.701-0.643-12.249c5.565-13.448,6.141,0.226,48.737,36.537   c23.744,20.241,71.219,79.461,162.606,121.548c19.259,8.87,20.297,13.351,27.028,10.585c0.547-0.225,1.456,0.183,2.106,0.491   c16.565,7.829,63.037,18.434,92.217,37.439c38.647,25.169,49.896,44.72,80.671,69.325c33.701,26.944,104.485,68.069,118.882,99.843   c48.231,106.447,89.551,92.035,99.412,101.997c4.2,4.244,11.482,7.509,16.375,7.266c2.862-0.143,2.855-0.128,7.462,2.058   c1.136,0.539,3.348-0.578,4.808,2.099c5.017,9.197,15.653,3.798,17.671,15.793c1.786,10.621,12.05,22.928,9.079,33.14   c-3.46,11.89-6.969,23.773-10.058,35.761c-2.708,10.511-11.495,21.686-5.522,32.085c7.072,12.311-11.624,10.094-14.403,31.48   c-0.252,1.938-0.653,3.675-2.4,4.739c-4.629,2.819-6.371,8.501-11.161,11.195c-0.685,0.385-1.165,1.506-1.342,2.367   c-2.743,13.383-15.33,16.278-32.226,37.619c-3.967,5.01-21.251,8.259-29.991,31.903c-0.857,2.317-1.299,4.841-2.812,6.98   c-4.145-4.088-8.813-7.283-11.598-12.072c-1.681-2.891-4.586-4.2-6.632-6.532c-1.747-1.991-2.085,2.06-4.078-0.637l-0.092,0.065   c-5.829-3.663-12.117-5.869-18.999-6.709c-9.24-1.127-8.667-10.94-10.156-12.395c-9.49-9.272-17.762-30.435-43.587-41.11   c-6.266-2.59-13.113-2.853-19.3-6.105c-10.22-5.372-26.711-6.446-36.113,0.859c-14.871,11.555-21.005,35.984-19.718,47.092   c-1.215-1.465-1.717-2.258-2.509-2.888c0.288,1.919,0.727,3.847,1.211,5.781c2.27,2.171,22.272,10.961,12.611,18.788   c-1.742,1.411-4.118,2.314-4.789,5.088c2.148,0.269,2.929-2.009,4.688-1.722l0.076-0.293c0,0,0.017,0.216,0.025,0.211   c-27.949,37.985-27.814,29.036-32.284,33.51c-0.551,1.821-1.587,3.516-2.966,4.964c0.131,0.15,0.29,0.288,0.467,0.397   c-0.913,2.469-2.982,3.513-5.21,4.708c-1.027,1.691-1.99,3.723-2.806,5.685c0.788,1.138,0.024,1.816-1.79,4.756   c-1.418,3.999-2.772,8.011-4.405,11.921c0.713,0.065,0.762,0.857,0.509,1.433c-1.612,3.668-0.591,7.721-1.475,11.358   c-4.566,18.795-2.184,37.42-2.175,38.422c0.234,26.408,0.777,16.241,2.927,31.721c0.218,1.572-0.143,4.707,3.301,2.629   c0.333-0.201,0.829,0.143,0.72,0.526c-0.969,3.407,4.504,5.196,2.239,8.983c-0.236,0.394,0.334,1.417,0.729,2.018   c4.69,7.154,6.122,15.362,7.719,23.529c2.771,14.18-17.93,69.556-26.053,85.476c0.231,0.206,0.462,0.411,0.694,0.615   c10.932-14.536,22.286-55.913,23.732-61.553c0.471-1.839,0.238-4.078,2.532-5.846c-0.071,1.025-1.391,25.409-4.056,34.896   c2.503-0.5,3.706-1.899,4.586-4.535c4.734-14.179,8.112-28.636,9.748-43.485c0.328-2.975,2.628-6.406-1.298-8.817   c-0.63-2.126-7.025-24.588-6.593-26.735c6.075,3.387,5.193,10.448,8.321,16.198c1.357-4.985-1.485-9.144-0.433-13.504   c5.023,5.128,5.675,11.923,1.901,33.272c3.871-7.665,2.849-15.3,4.339-22.996c4.08,5.633,7.545,10.61,12.936,13.792   c1.244,0.734,2.771,1.4,2.923,3.091c0.16,1.774-0.003,3.309,2.538,1.623c0.783-0.52,6.665,4.613,6.274,5.467   c-1.781,3.896,1.865,3.964,3.295,3.882c5.213-0.3,10.152,1.369,15.283,1.521c15.629,0.463,12.633,5.611,15.989,6.638   c4.825,1.477,12.261,16.591,14.381,24.804c2.453,9.499,10.265,9.759,18.839,5.99c8.218-3.613,5.381,2.307,16.143,8.617   c6.397,3.751,14.268,2.653,20.758,6.187c0.431,0.235,1.096,0.068,1.65,0.044c14.329-0.599,35.916,20.467,45.094-11.332   c8.065-27.941,7.974-27.487,8.712-29.238c2.363-5.613,8.211,9.377,8.673,12.785c1.932,14.264-0.064,27.207,4.237,44.627   c20.756,84.057,10.996,83.943,11.231,121.463c0.239,38.167,18.453,168.38,15.173,202.706c-0.402-5.307,0.621-8.761-2.263-8.596   c-1.926,0.111-1.879,1.98-1.899,3.46c-0.04,2.964-0.416,5.994,0.058,8.88c1.144,6.968-3.319,19.058-7.674,18.907   c-1.15-0.04-2.263,0.724-2.239,2.013c0.064,3.392-3.606,2.908-10.906,4.546c-14.435,3.24-8.766,4.689-16.834,6.481   c-34.099,7.571,1.173,6.767-52.447,20.286c-12.76,3.217-25.307,7.084-37.944,10.671c-6.725,1.909-6.57,2.153-4.965,8.822   c1.095,4.55,3.473,2.113,7.364,3.963c11.725,5.575,14.022,0.003,18.782,1.649c4.99,1.725,6.537-1.526,13.155-0.584   c12.742,1.815,38.323-3.793,49.919-6.253c18.673-3.963,25.775,6.116,31.974,2.022c0.458-0.302,1.456-0.002,2.116,0.25   c5.035,1.919,9.762,0.877,14.523-1.137c8.738-3.695,14.972,7.175,26.858-0.745c3.851-2.566,94.482-7.881,99.079-7.891   c2.003-0.005,4.33-0.21,5.35-2.31c12.985-26.724-2.263-12.135,3.214-53.587c0.215-1.624,0.814-4.08-0.675-4.665   c-3.965-1.557-2.393-4.463-2.221-6.959c0.337-4.88,29.275-139.837,30.738-174.591c1.648-39.122-0.694-5.239,3.545-43.372   c3.527-31.722-3.998-26.134-7.022-72.973c-2.054-31.824-3.266-33.683-2.782-40.883c0.125-1.869,0.234-3.629-0.207-5.455   c-5.419-22.459,1.51-79.736-6.304-126.759c-3.162-19.032-7.103-19.981-0.18-21.381c3.535-0.715,17.918-1.968,27.528-6.083   c1.334-0.571,2.851-0.97,4.29-0.994c5.954-0.099,11.73-1.575,17.62-2.105c5.089-0.457,9.042-2.551,11.937-6.933   c8.25-12.485,15.352-6.581,24.951-21.275c4.278-6.548,11.729-8.761,17.96-25.558c6.523-17.582,14.6-31.97,9.831-52.953   c-3.141-13.822,1.96-17.421,2.535-23.228c2.329-23.491,29.7-47.734,18.998-102.115c-2.156-10.957-46.282-147.221-46.705-148.221   c-0.484-1.146-0.079-2.163,0.777-3.02c3.464-3.47,1.766-6.729-0.425-9.956c-3.005-4.424-1.024,3.135-3.922-15.651   c-0.354-2.299-0.805-4.664,0.573-7.201c11.295,3.583,22.874,1.331,27.627,1.708c245.919,19.528,261.845-13.442,273.349-56.941   c1.51-5.708,3.12-11.385,3.183-17.409C1393.813,519.35,1348.973,498.288,1339.623,490.369z M611.409,998.368   c0.109-0.534,0.441-0.867,0.948-1.043C612.298,997.902,611.974,998.242,611.409,998.368z M612.656,997.137   c0.461-0.379,0.923-0.757,1.385-1.135C614.162,997.219,613.365,997.115,612.656,997.137z M923.078,1561.834   c-5.517,6.118,8.74,7.403,2.158,10.858c-2.147,1.127-0.035,4.233-2.712,4.881c-1.974,0.478-4.303,0.607-5.784,1.77   c-8.559,6.72-19.11,4.524-17.332-9.385c18.076-141.43,23.343-154.289,20.709-191.033c-2.538-35.416,4.689-27.141-1.15-62.411   c-6.232-37.646-2.169,7.501-6.311-42.116c-4.115-49.292-6.095-43.772-5.368-56.204c0.5-8.552-1.664-8.94-1.229-13.165   c3.247-31.541,0.219-59.393-5.839-81.736c1.459,1.684,17.734,24.556,19.479,39.866c0.114,1,10.288,116.255,10.786,126.383   c0.82,16.684-13.833,60.165-3.83,101.866c0,0,5.125,60.721,4.984,55.712C932.266,1469.416,929.936,1554.229,923.078,1561.834z"
                />
                <path
                  d="M900.295,1122.974l-0.082,0.296c-0.009-0.032-0.016-0.064-0.025-0.096L900.295,1122.974z"
                />
                <path
                  d="M586.173,1232.221c-0.292,1.522-1.38,2.303-2.682,2.885l-0.102,0.074c0.784-1.14,0.882-2.682,2.09-3.574   C585.71,1231.811,585.942,1232.016,586.173,1232.221z"
                />
                <path
                  d="M606.672,1200.487c0.556-0.224,1.111-0.449,1.674-0.669c0.008,0.004-0.108-0.074-0.1-0.068   c-0.546,0.215-1.099,0.424-1.653,0.634L606.672,1200.487z"
                />
                <path
                  d="M606.594,1200.384c0.034,0.041,0.069,0.083,0.091,0.114C606.672,1200.487,606.594,1200.384,606.594,1200.384z"
                />
                <path
                  d="M782.593,952.971l0.161-0.268C782.691,952.863,782.7,952.895,782.593,952.971z"
                />
                <path
                  d="M583.491,1235.105l-0.106,0.268C583.405,1235.155,583.384,1235.183,583.491,1235.105z"
                />
              </g>
            </svg>
            <p>Novi trošak</p>
          </button>

          <Period
            @dates="startPeriod"
            @filter-period="filterItems"
            :isGrid="true"
          />
        </div>

        <search-bar
          :searchStr="search"
          :pageSizeNr="pageSize"
          :searchType="'traži (mjesec, godina, trošak, iznos)'"
          @changed="setPageSize"
          @typed="searchItems"
        />

        <div class="">
          <div class="days__list expenses__header">
            <span>Za Period</span>
            <!-- <span>Mjesec</span> -->
            <span>Trošak</span>
            <span>Datum</span>
            <span>Iznos</span>
            <span>Napomena</span>
          </div>

          <div
            v-for="expense in pageOfItems"
            :key="expense._id"
            @click="selectExpense(expense)"
            class="clients__list expense__list"
          >
            <p class="client__item">
              {{ expense.expense_year }} / {{ expense.expense_month }}
            </p>
            <!-- <p class="client__item">{{ expense.expense_month }}</p> -->
            <p class="client__item">{{ expense.expense_title }}</p>
            <p class="client__item">{{ expense.expense_date | formatDate }}</p>
            <p class="client__item">{{ expense.expense_amount }}</p>
            <p class="client__item">{{ expense.notes }}</p>
          </div>
          <div class="days__list expenses__header">
            <h4 class="total__exp">UKUPNO :</h4>
            <h4 class="page__total_exp">{{ pageTotalAmount }}</h4>
          </div>
        </div>
      </div>
    </div>
    <!-- </transition> -->

    <jw-pagination
      :items="filteredClients"
      @changePage="onChangePage"
      :initialPage="initialPage"
      :pageSize="pageSize"
      :labels="customLabels"
      :styles="customStyles"
      class="pagine"
    >
    </jw-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loading from '@/components/utils/Loading.vue';
import { customLabels, customStyles } from '@/components/utils/pageNav.js';
import SearchBar from '@/components/utils/SearchBar.vue';
import Period from '@/components/utils/Period.vue';
import navigation from '@/mixins/navigation';
import navigationSearch from '@/mixins/navigationSearch';
import searchClients from '@/mixins/searchClients';
import dayjs from 'dayjs';
import sr from 'dayjs/locale/sr';

dayjs.locale(sr);

export default {
  name: 'Expenses',

  components: {
    Loading,
    SearchBar,
    Period,
  },

  mixins: [navigation, navigationSearch, searchClients],

  data() {
    return {
      customLabels,
      customStyles,
    };
  },

  computed: {
    ...mapGetters([
      'getAllExpenses',
      'getClientsPage',
      'getClientsPageSize',
      'loadingState',
    ]),

    pageTotalAmount: function () {
      return this.filteredClients.reduce((a, b) => a + b.expense_amount, 0);
    },
  },

  methods: {
    ...mapActions([
      'fetchExpenses',
      'fetchExpense',
      'fetchClientsPage',
      'fetchClientsPageSize',
      'expenseClear',
      'setLoadingState',
    ]),

    async newExpense() {
      this.setLoadingState(true);
      this.$router.push('/expense');
      await this.expenseClear();
    },

    async selectExpense(expense) {
      this.setLoadingState(true);
      await this.fetchExpense(expense);
      this.$router.push('/expense');
    },

    mapExpenses(expense) {
      return expense.reduce((a, expense_amount) => a + expense_amount, 0);
    },

    async searchItems(val = '') {
      await this.initItems();
      let mu = this.getAllExpenses.filter((post) => {
        return (
          post.expense_year.toString().includes(val) ||
          post.expense_month.toLowerCase().includes(val.toLowerCase()) ||
          post.expense_title.toLowerCase().includes(val.toLowerCase()) ||
          post.expense_amount.toString().includes(val)
        );
      });
      this.filteredClients = mu;
    },

    startPeriod(dateFrom, dateTill) {
      this.filterItems(dateFrom, dateTill);
    },

    filterItems(dateFrom, dateTill) {
      let mu = this.getAllExpenses.filter(
        (year) =>
          dayjs(year.expense_date).format('YYYY-MM-DD') >=
            dayjs(dateFrom).format('YYYY-MM-DD') &&
          dayjs(year.expense_date).format('YYYY-MM-DD') <=
            dayjs(dateTill).format('YYYY-MM-DD')
      );
      this.filteredClients = mu;
    },

    async initItems() {
      if (!this.getAllExpenses.length) await this.fetchExpenses();
      this.filteredClients = this.getAllExpenses.sort();
      this.filteredClients.sort((a, b) =>
        a.expense_date > b.expense_date ? -1 : 1
      );
      if (this.getClientsPage !== 1) this.initialPage = this.getClientsPage;
      if (this.getClientsPageSize !== 10)
        this.pageSize = this.getClientsPageSize;
    },
  },

  async mounted() {
    await this.initItems();
    this.setLoadingState(false);
  },
};
</script>

<style>
.expense__list {
  grid-template-columns: repeat(5, 1fr);
  justify-items: center;
}

.expenses__header {
  grid-template-columns: repeat(5, 1fr);
}

.total__exp {
  grid-area: 1 / 4 / 2 / 5;
}

.page__total_exp {
  grid-area: 1 / 5 / 2 / 6;
}
</style>
